import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';
import ClipLoader from "react-spinners/ClipLoader";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import api from '../../services/api';

const styles = {
  cardTitleWhite: {
    fontSize: '31px',
    color: "#1989FF",
    textAlign: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px',
  },

  textInfo: {
    color: '#828282',
    height: '0px',
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '700',
    marginTop: 10
  },
};

const useStyles = makeStyles(styles);

export default function Restrito() {
  const classes = useStyles();
  const history = useHistory();
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);  
  const [sisRegPonto, setSisRegPonto] = useState('');  

  useEffect(() => {
    (async () => {
      try {
        let usuario = await api.getUsuario();
          
        if (usuario.success) {
          if (usuario.data.sisRegPonto == 4) {
            setSisRegPonto('O usuário logado não tem permissão de uso do sistema de registro de ponto eletrônico web.');          
          } else
          if (usuario.data.sisRegPonto == 1) {
            setSisRegPonto('O usuário logado só tem permissão de uso do sistema de registro de ponto eletrônico mobile.');          
          }
        };
      } catch (err) {
        setLoading(false);
        if (err.statusCode === 401) {
          localStorage.clear();
          history.push("/");
          addToast(err.message, { appearance: 'error' });
        } else {
          addToast(err.message, { appearance: 'error' });
        }
      }
    })();
  }, []);

  return (
    <div className={classes.gridContainer}>
      <GridContainer style={{ position: 'fixed', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center', zIndex: 1 }}>
        
          <Card style={{
            backgroundColor: '#f8f9fd',
            borderRadius: 25,
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            borderColor: '#C8C8C8',
            height: '300px',
            width: '700px',
            boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
          }}>
            <CardHeader style={{ height: '30px', marginTop: 20 }}>
              <h4 className={classes.cardTitleWhite} style={{
                fontWeight: 400,
                color: '#1989ff',
                fontSize: 22,
                lineHeight: '28px'
              }}>SISTEMA DE REGISTRO DE PONTO</h4>
            </CardHeader>

            <CardHeader style={{ padding: '8px 5px 0px 5px', justifyContent: 'center', borderBlockEnd: '1px solid #ddd', textAlign: 'center' }}>
                <label className={classes.textInfo}>
                  USO RESTRITO
                </label>
              </CardHeader>
              
            <div style={{ marginTop: 0, height: 300, width: 700, overflowX: 'auto' }}>
              <CardBody style={{ padding: 0 }}>
                <GridItem xs={12} sm={12} md={12} >              
                  <p align="center">
                    <br></br>
                    {sisRegPonto}
                    <br></br><br></br>
                    Com o acesso restringido, o usuário não poderá bater ponto e justificar batidas.
                    <br></br><br></br>
                    Para mais informações, entre em contato com o setor de RH da empresa.
                  </p>                  
                </GridItem>              
              </CardBody>
            </div>

            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
              <ClipLoader
                size={80}
                color={"#364e6b"}
                loading={loading}
                css={{ border: '8px solid', borderBottomColor: 'transparent' }}
              />
            </div>
          </Card>        
      </GridContainer>
    </div>
  );
}
